module.exports = __webpack_public_path__ + "media/夜市.40cdbe55.wav";